export const WATERFALL_GRAPH = 'WATERFALL_GRAPH';

export const WATERFALL_PIPELINE_CONFIG_DATA = 'WATERFALL_PIPELINE_CONFIG_DATA';
export const WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS = 'WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS';
export const WATERFALL_PIPELINE_CONFIG_DATA_ERROR = 'WATERFALL_PIPELINE_CONFIG_DATA_ERROR';
export const WATERFALL_GRAPH_CONFIG = 'WATERFALL_GRAPH_CONFIG';

export const WATERFALL_EVENTS_DATA = 'WATERFALL_EVENTS_DATA';
export const WATERFALL_EVENTS_DATA_SUCCESS = 'WATERFALL_EVENTS_DATA_SUCCESS';
export const WATERFALL_EVENTS_DATA_ERROR = 'WATERFALL_EVENTS_DATA_ERROR';

export const WATERFALL_EVENTS_UPDATE = 'WATERFALL_EVENTS_UPDATE';
export const WATERFALL_EVENTS_UPDATE_SUCCESS = 'WATERFALL_EVENTS_UPDATE_SUCCESS';
export const WATERFALL_EVENTS_UPDATE_ERROR = 'WATERFALL_EVENTS_UPDATE_ERROR';
